<template>
  <div class="service-list-zx" :class="{ 'hp-hide': scrollDirection === 1 }">
    <!-- 第二层tab -->
    <div
      class="two-floor-tabs ab-test"
      :style="{ top: zxStickOffsetTop + 'px' }"
      v-show="showZxTabs"
    >
      <div class="wrap">
        <ul>
          <li
            class="two-tab"
            :class="{
              active: currentZxTabIndex === index
            }"
            v-for="(tab, index) in zxTabList"
            :key="tab.name"
            @click="onZxTabChange(tab, index)"
          >
            {{ tab.title }}
          </li>
        </ul>
        <div class="mask"></div>
      </div>
    </div>

    <consultPanel
      v-if="isOpenService"
      ref="ConsultPanel"
      :tabData="{ name: 'consult', title: '基础' }"
    ></consultPanel>

    <upgradePkgs
      v-if="isOpenService && activities.length"
      ref="UpgradePkgs"
      :tabData="{ name: 'pkgs', title: '精选' }"
    />

    <!-- <couponPanel
      v-if="
        isOpenService &&
        !abTestHomepageV31 &&
        (coupons.length || meals.length || activities.length)
      "
      ref="CouponPanel"
      :tabData="{ name: 'coupon', title: '优惠' }"
      :coupons="coupons"
      :meals="meals"
      :activities="activities"
    ></couponPanel> -->

    <evaluatePanel
      v-if="isOpenService && rateList.length"
      ref="evaluatePanel"
      :tabData="{ name: 'rate', title: '评价' }"
      @toRateTab="toRateTab"
    />

    <authorDescPanel
      v-if="introduction"
      ref="AuthorDesc"
      :tabData="{ name: 'desc', title: '简介' }"
      :introduction="introduction"
    ></authorDescPanel>

    <goodAtPanel
      ref="GoodAt"
      :tabData="{ name: 'goodat', title: '擅长' }"
    ></goodAtPanel>

    <certificationPanel
      ref="Certification"
      :tabData="{ name: 'cert', title: '资质' }"
    ></certificationPanel>

    <interviewPanel
      v-if="interviewList.length"
      ref="Interview"
      :tabData="{ name: 'interview', title: '访谈' }"
    ></interviewPanel>

    <knowPanel
      v-if="knowList.length"
      ref="know"
      :tabData="{ name: 'know', title: '须知' }"
      :list="knowList"
    ></knowPanel>

    <!-- <div v-if="isRateTab" class="to-rate" @click="toRateTab">
      <p>查看ta收到的评价</p>
      <van-icon name="arrow" color="#FFA202" />
    </div> -->
  </div>
</template>

<script>
import consultPanel from 'component/platform/homepage/consultTeacher/consultPanel.vue'
import upgradePkgs from 'component/platform/homepage/consultTeacher/upgradePkgs.vue'
// import couponPanel from 'component/platform/homepage/consultTeacher/couponPanel.vue'
import evaluatePanel from 'component/platform/homepage/consultTeacher/evaluatePanel.vue'
import certificationPanel from 'component/platform/homepage/consultTeacher/certificationPanel.vue'
import goodAtPanel from 'component/platform/homepage/consultTeacher/goodAtPanel.vue'
import authorDescPanel from 'component/platform/homepage/consultTeacher/authorDescPanel.vue'
import interviewPanel from 'component/platform/homepage/consultTeacher/interviewPanel.vue'
import knowPanel from 'component/platform/homepage/consultTeacher/knowPanel.vue'
import { getOffsetTop } from 'lib/tools/domUtil.js'
// import { Icon as VanIcon } from 'vant'
const trim = str => str.replace(/\s*$/g, '')

export default {
  components: {
    interviewPanel,
    authorDescPanel,
    goodAtPanel,
    certificationPanel,
    // couponPanel,
    consultPanel,
    upgradePkgs,
    knowPanel,
    evaluatePanel
    // VanIcon
  },
  props: {
    showZxTabsDistance: Number,
    scrollDirection: Number
  },
  data() {
    return {
      panelRefs: [],
      zxTabList: [],
      showZxTabs: false,
      currentZxTabIndex: -1
    }
  },
  computed: {
    rateList() {
      return this.$store.state.homepage.serviceTabRateList
    },
    distance() {
      return this.$store.state.homepage.distance
    },
    zxStickOffsetTop() {
      return this.$store.getters['homepage/zxStickOffsetTop']
    },
    consultServiceInfo() {
      return this.$store.getters['homepage/consultServiceInfo']
    },
    introduction() {
      return this.consultServiceInfo.introduction || ''
    },
    interviewList() {
      return this.$store.getters['homepage/interviewList']
    },
    knowList() {
      const {
        response_desc = '',
        change_desc = '',
        delay_desc = ''
      } = this.consultServiceInfo
      return [
        {
          title: '回应时长',
          desc: trim(response_desc),
          icon: require('images/platform/homepage/icon-know-new.png')
        },
        {
          title: '变更预约说明',
          desc: trim(change_desc),
          icon: require('images/platform/homepage/icon-know-new.png')
        },
        {
          title: '爽约/迟到说明',
          desc: trim(delay_desc),
          icon: require('images/platform/homepage/icon-know-new.png')
        }
      ].filter(v => !!v.desc)
    },
    /*优惠和活动面板--start */
    coupons() {
      const { coupons = [] } = this.$store.state.homepage.zxAdvancedInfo
      return coupons.map(v => {
        return { name: v.show_name }
      })
    },
    meals() {
      const { packages = [] } = this.$store.state.homepage.zxAdvancedInfo
      return packages
    },
    activities() {
      const { activities = [] } = this.$store.state.homepage.zxAdvancedInfo
      return activities
    },
    /*优惠和活动--end */
    // 咨询师正常&咨询师开启预约
    isOpenService() {
      const { teacher_status } = this.consultServiceInfo
      return +teacher_status === 1
    },
    // 是否显示评价tab
    isRateTab() {
      let list = this.$store.getters['homepage/getRateListData'] || []
      return list.length > 0
    }
  },
  watch: {
    panelRefs: {
      handler() {
        this.zxTabList = this.panelRefs
          .map(v => v.$attrs && v.$attrs.tabData)
          .filter(v => !!v)
      },
      immediate: true
    }
  },
  mounted() {
    this.scrollHander = this._scrollHander.bind(this)
    window.addEventListener('scroll', this.scrollHander)

    this.$nextTick(() => {
      this.getRefs()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHander)
  },
  methods: {
    onZxTabChange(tab, index) {
      this.$trackEvent('newprofilepages_consulttab_click', {
        button_name: tab.title
      })
      this.currentZxTabIndex = index

      // 点击到指定板块
      let oh = this.distance.headerHeight + this.distance.zxNavHeight
      if (this.scrollDirection !== 1) {
        oh += this.distance.navHeight
      }
      const refs = this.getRefs()
      const top = getOffsetTop(refs[index].$el)

      // 300毫秒内，不获取滚动方向，不触发_scrollHandler
      window.yxl = window.yxl || {}
      window.yxl.ignoreScrollDirection = true
      window.yxl.ignoreScrollHandler = true
      setTimeout(() => {
        window.yxl.ignoreScrollDirection = false
        window.yxl.ignoreScrollHandler = false
      }, 300)

      // 加多5px,防止定位不足
      const distance = top - oh + 5
      document.documentElement.scrollTop = distance
      document.body.scrollTop = distance
    },
    // 父组件、本组件都会调用。
    getRefs() {
      const {
        ConsultPanel,
        // CouponPanel,
        UpgradePkgs,
        evaluatePanel,
        AuthorDesc,
        GoodAt,
        Certification,
        Interview,
        know
      } = this.$refs

      this.panelRefs = [
        ConsultPanel,
        // CouponPanel,
        UpgradePkgs,
        evaluatePanel,
        AuthorDesc,
        GoodAt,
        Certification,
        Interview,
        know
      ].filter(item => !!item)

      return this.panelRefs.filter(ref => ref.$el.nodeType === 1) // 只取元素节点
    },
    _scrollHander() {
      const t = document.documentElement.scrollTop || document.body.scrollTop
      this.showZxTabs = t > this.showZxTabsDistance

      if (window.yxl && window.yxl.ignoreScrollHandler === true) {
        return
      }
      const oh =
        this.distance.headerHeight +
        this.distance.navHeight +
        this.distance.zxNavHeight

      const refs = this.getRefs()
      let index = -1
      // 判断当前哪个区块高亮
      for (let i = 0; i < refs.length; i++) {
        let ref = refs[i]
        const { top, bottom } = ref.$el.getBoundingClientRect()
        if (top <= oh && bottom > oh) {
          index = i
          break
        }
      }
      this.currentZxTabIndex = index
    },
    toRateTab() {
      this.$trackEvent('newprofilepages_bottom_evaluate', {})
      this.$emit('toRate')
    }
  }
}
</script>

<style lang="scss" scoped>
.service-list-zx {
  .two-floor-tabs {
    &.ab-test {
      background: #fff;
      border-radius: 10px;
      height: 88px;
      .wrap {
        position: relative;
        width: 100%;
        height: 50px;
        overflow: hidden;
        display: flex;
        align-items: center;
        border-radius: 0.1333333rem;
        background: #f3f4f5;
        ul {
          overflow: auto;
          display: flex;
          align-items: center;
          position: relative;
          width: calc(10rem - 60px);
          z-index: $hp_zIndex_tababr;
          box-sizing: border-box;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;
          white-space: nowrap;
          &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }
          .two-tab {
            height: 44px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #6c798c;
            line-height: 26px;
            height: auto !important;
            &.active {
              background: #ffffff;
              border-radius: 8px;

              font-size: 26px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #6982fa;
              line-height: 44px;
            }
          }
        }
        .mask {
          position: absolute;
          display: inline-block;
          content: '';
          width: 91px;
          height: 50px;
          top: 0;
          right: 0;
          background: #000;
          background: -webkit-linear-gradient(
            left,
            hsla(0, 0%, 100%, 0),
            #f3f4f5
          );
          background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #f3f4f5);
          border-radius: 0 0.13333rem 0.13333rem 0;
          pointer-events: none;
          z-index: 9;
        }
      }
    }
  }
  .two-floor-tabs {
    overflow: scroll;
    transition: transform 0.2s linear;
    display: flex;
    align-items: center;
    height: 88px;
    position: fixed;
    left: 50%;
    background-color: #fff;
    width: calc(10rem - 60px);
    transform: translate3d(-50%, 0, 0);
    z-index: $hp_zIndex_tababr;
    box-sizing: border-box;
    .two-tab {
      word-break: keep-all;
      padding: 0 16px;
      height: 60px;
      background: #f3f4f5;
      border-radius: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        background: #6982fa;
        color: #ffffff;
      }
    }
  }
  .to-rate {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffa202;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    img {
      width: 14px;
      height: 14px;
      object-fit: cover;
      margin-left: 6px;
    }
  }
}
</style>
